import { Icon, type IconProps } from "@chakra-ui/react";

function BoxIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 34 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M31.1666 10.6296L16.9999 18.5M16.9999 18.5L2.83328 10.6296M16.9999 18.5L17 34.3333M32 25.2643V11.7357C32 11.1647 32 10.8791 31.9159 10.6245C31.8414 10.3992 31.7197 10.1924 31.5589 10.0179C31.3772 9.82066 31.1276 9.682 30.6284 9.40466L18.2951 2.55281C17.8224 2.29021 17.586 2.15891 17.3358 2.10744C17.1142 2.06188 16.8858 2.06188 16.6643 2.10744C16.414 2.15891 16.1776 2.29021 15.705 2.55281L3.37162 9.40466C2.87241 9.682 2.62281 9.82067 2.44106 10.0179C2.28026 10.1924 2.15858 10.3992 2.08414 10.6245C2 10.8791 2 11.1647 2 11.7357V25.2643C2 25.8353 2 26.1209 2.08414 26.3755C2.15858 26.6008 2.28026 26.8076 2.44106 26.9821C2.62281 27.1793 2.87241 27.318 3.37162 27.5953L15.705 34.4472C16.1776 34.7098 16.414 34.8411 16.6643 34.8926C16.8858 34.9381 17.1142 34.9381 17.3358 34.8926C17.586 34.8411 17.8224 34.7098 18.2951 34.4472L30.6284 27.5953C31.1276 27.318 31.3772 27.1793 31.5589 26.9821C31.7197 26.8076 31.8414 26.6008 31.9159 26.3755C32 26.1209 32 25.8353 32 25.2643Z"
				stroke="currentColor"
				strokeWidth="3.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default BoxIcon;
